export const ColorPickerOptions = [
  '#E6E6E6',
  '#F1D2CC',
  '#EFCCB2',
  '#F6E7AF',
  '#DEEBC5',
  '#CBE0F2',
  '#CDDADF',
  '#DFD0EC',
  '#BDBDBD',
  '#E3A89D',
  '#E3A982',
  '#E4CE73',
  '#B9D890',
  '#99C0E0',
  '#A7C1B1',
  '#BC91E1',
  '#7D7D7D',
  '#BF6B5D',
  '#C37345',
  '#B59B33',
  '#7DA850',
  '#5A8EBB',
  '#6C8F9A',
  '#844BB5',
  '#3D3D3D',
  '#952C20',
  '#663E1C',
  '#433829',
  '#436F51',
  '#30509D',
  '#3B5868',
  '#51347D',
];
